import {h, Fragment} from "preact"
export default function Checkbox({ identifier, value, selected, count, onChange, className }) {
    return (
        <>
            <input
                id={identifier}
                className="peer input block appearance-none overflow-hidden text-transparent w-5 h-5 rounded-none border border-black cursor-pointer relative checked:before:absolute checked:before:block checked:before:top-[3px] checked:before:left-[3px] checked:before:right-[3px] checked:before:bottom-[3px] checked:before:bg-gray-900 checked:border checked:border-black focus:border focus:!border-black hover:!border-black hover:border"
                type="checkbox" 
                checked={selected} 
                onChange={onChange}
            />
            <label 
                for={identifier}
                class="cursor-pointer peer-checked:font-medium body-2 mt-0.5"
            >
                {value} ({count})
            </label>
        </>
    )
}